var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isInitialized
    ? _c(
        "div",
        [
          _vm.hasConversations && !_vm.hasStartAt
            ? _c(
                "div",
                { staticClass: "alert alert-info", attrs: { role: "alert" } },
                [_vm._v("\n    " + _vm._s(_vm.estimateMessage) + "\n  ")]
              )
            : !_vm.hasConversations && !_vm.hasStartAt
            ? _c(
                "div",
                {
                  staticClass: "alert alert-warning",
                  attrs: { role: "alert" },
                },
                [_vm._v("\n    No messages will be sent.\n  ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.hasExceptions
            ? _c("exception-list", {
                staticClass: "alert alert-warning",
                attrs: { items: _vm.exceptions, role: "alert" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("p", [
            _vm._v("\n    Send List: "),
            _c("strong", [_vm._v(_vm._s(_vm.sendListName))]),
          ]),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.isBusy,
                  expression: "isBusy",
                },
              ],
              ref: "form",
              attrs: { model: _vm.form, rules: _vm.rules },
            },
            [
              _c(
                "el-collapse",
                {
                  on: { change: _vm.handleActiveCollapse },
                  model: {
                    value: _vm.activeCollapse,
                    callback: function ($$v) {
                      _vm.activeCollapse = $$v
                    },
                    expression: "activeCollapse",
                  },
                },
                [
                  _c(
                    "el-collapse-item",
                    { attrs: { title: "Schedule", name: "schedule" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "Start At", prop: "start_at" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetime",
                              placeholder: "Start",
                              format: _vm.dateFormat,
                              "value-format": _vm.formDateFormat,
                            },
                            model: {
                              value: _vm.form.start_at,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "start_at", $$v)
                              },
                              expression: "form.start_at",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { prop: "body", label: "Message" } },
                [
                  _c("MessageControl", {
                    staticClass: "d-inline-block w-100",
                    attrs: {
                      "approved-message-list-url": _vm.approvedMessageListUrl,
                      "can-send-sms": _vm.can.sendSms,
                      "can-send-approved-sms": _vm.can.sendApprovedSms,
                    },
                    model: {
                      value: _vm.form.body,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "body", $$v)
                      },
                      expression: "form.body",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary px-4",
                    attrs: { disabled: _vm.isSendButtonDisabled },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.save.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("Send")]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }